import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { easeOut } from '../../utils/motion';
import { CartDrawer } from '../cart/CartDrawer';
import { AnnouncementBar } from './AnnouncementBar';
import { Footer } from './Footer';
import { Header } from './Header';
export function Layout() {
  const location = useLocation();
  const reduce = useReducedMotion();
  return <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-424" data-mp="35350fzdynqj2">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-ink focus:px-4 focus:py-2 focus:text-paper" data-id="element-425" data-mp="3a1esi14e2b0g">
        Aller au contenu
      </a>
      <AnnouncementBar data-id="element-426" data-mp="3j0tmhajrl3pp" />
      <Header data-id="element-427" data-mp="1kntcgnbw3npq" />
      <motion.main id="contenu" key={location.pathname} initial={reduce ? false : {
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: easeOut
    }} className="flex-1" data-id="element-428" data-mp="1kobha8cmba99">
        <Outlet data-id="element-429" data-mp="3n2mvquai285j" />
      </motion.main>
      <Footer data-id="element-430" data-mp="3i9tnvxjqijp8" />
      <CartDrawer data-id="element-431" data-mp="3i9bjueqtz16r" />
    </div>;
}